import { useDispatch } from 'react-redux'

import { useLoggedInUser } from '~shared-components/hooks/useLoggedInUser'
import { setSelectedContextAction } from '~shared-components/redux/actions/login.actions'
import { saveSelectedContextState } from '~shared-components/redux/localStorage'
import { CustomerContext } from '~shared-components/transforms/user.transforms'

import { useSelectSalesGroup } from './useSelectSalesGroup'

export const useSelectContext = () => {
  const { user } = useLoggedInUser()
  const dispatch = useDispatch()
  const { isLoadingGroup, setSelectSalesGroup } = useSelectSalesGroup()

  const setSelectContext = async (
    selectedContext: CustomerContext | undefined,
    selectedLocationId: string | undefined = selectedContext?.shipToAddresses[0]
      .id,
  ) => {
    const id = selectedContext?.customerContextId
    const salesGroup = selectedContext?.salesGroup

    user!.currentCustomerContextId = id
    saveSelectedContextState(user!.email, {
      selectedContextId: id ?? '',
      selectedLocationId,
    })
    dispatch(
      setSelectedContextAction({
        context: selectedContext,
        locationId: selectedLocationId ?? '',
      }),
    )

    if (salesGroup) {
      await setSelectSalesGroup(salesGroup)
    }
  }

  return { isLoadingContext: isLoadingGroup, setSelectContext }
}
